import ReactDOM from "react-dom";
import { StrictMode } from "react";
import AppProviders from "./AppProviders";
import AppContainer from "./containers/AppContainer";
import { createReduxStore } from "./redux";
import "./index.scss";
import ErrorBoundaryWrapper from "./ErrorBoundaryWrapper";

const { store, persistor } = createReduxStore();

ReactDOM.render(
  <StrictMode>
    <ErrorBoundaryWrapper>
      <AppProviders store={store} persistor={persistor}>
        <AppContainer />
      </AppProviders>
    </ErrorBoundaryWrapper>
  </StrictMode>,
  document.getElementById("root")
);
